/**
 * Redact any value that appears with the property name "request". Picks out specific values and returns only those
 * in order to avoid logging too much. Also has perf benefits as we avoid recursively redacting the entire request
 * object.
 */
export const redactRequestProperty = {
    // Handle request being included in errors.
    test: (propertyName, value) => propertyName === 'request' && typeof value === 'object' && value !== null,
    replacement: (value) => ({
        uri: value.uri,
        method: value.method,
        headers: {
            'X-Caller-Client-ID': value.headers && value.headers['X-Caller-Client-ID'],
        },
    }),
};
//# sourceMappingURL=redactRequestProperty.js.map